import React, { useState, useEffect } from 'react';
import { Card, Table, Badge, Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { PHANBIENDOCLAP_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { Get } from '../../../../utils/httpProvider';

const PhanBienDocLap = ({ hoSoId }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    
    const { isLoading, data: queryData } = useQuery(
        ['phanBienDocLapData', hoSoId],
        () => Get(`${PHANBIENDOCLAP_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    // Xử lý data từ API
    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else {
            dataList = [queryData];
        }
    }

    useEffect(() => {
        if (dataList && dataList.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = dataList.find(item => item.id === prev.id);
                    return fresh || dataList[0];
                }
                return dataList[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [dataList]);

    return (
        <>
        <Card className="card-sticky-layout">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Phản biện độc lập</h5>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th className="text-center">Tên phản biện độc lập</th>
                                        <th className="text-center">Biên bản giải trình</th>
                                        <th className="text-center">File đính kèm</th>
                                    </tr>
                                </thead>
                            <tbody>
                                {dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                        <tr 
                                            key={item.id}
                                            onClick={() => setSelectedRow(item)}
                                            style={{ cursor: 'pointer' }}
                                            className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                        >
                                            <td className="text-center">{index + 1}</td>
                                            <td className="text-center">{item.tenPhanBien || ''}</td>
                                            <td className="text-center">
                                                {item.isBanGiaiTrinh ? <Badge variant="success">Có</Badge> : <Badge variant="danger">Không</Badge>}
                                            </td>
                                            <td className="text-center">
                                                {item.fileDinhKem ? (
                                                    (() => {
                                                        const path = item.fileDinhKem;
                                                        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                        const safePath = path.startsWith('/') ? path : `/${path}`;
                                                        const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                        let name = path.split('/').pop() || 'File';
                                                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                        return (
                                                            <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                                <i className="fas fa-paperclip mr-1"></i> {name}
                                                            </a>
                                                        );
                                                    })()
                                                ) : (
                                                    <span className="text-muted">Không có</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            Chưa có dữ liệu Phản biện độc lập (chỉ hiển thị khi Phòng HLĐT xác định và thêm mới)
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        </div>
                    </>
                )}
            </Card.Body>
        </Card>
        </>
    );
};

export default PhanBienDocLap;
